<template>
  <page-outline class="page" :title="$t('Webheader.sdd_global_settings')">
    <template slot="pageContent">
      <spinner v-if="activateSpinner"></spinner>
      <div v-else>
        <div class="mt-0">
          <b-row class="text-xl-start mb-1">
            <b-col xl="9" lg="12" md="12" cols="12">

              <!-- Super-menu : Global / Core / B2B -->
              <b-button-group class="mt-3 mt-sm-0">
                <b-button class="px-4" :variant="superTab === 'global' ? 'primary btn-selected' : ''"
                  @click="superTab = 'global'">Global</b-button>
                <b-button class="px-4" :variant="superTab === 'core' ? 'primary btn-selected' : ''"
                  @click="superTab = 'core'">Core</b-button>
                <b-button class="px-4" :variant="superTab === 'b2b' ? 'primary btn-selected' : ''"
                  @click="superTab = 'b2b'">B2B</b-button>
              </b-button-group>
              <div class="mb-2"></div>
              <!-- Sous-menu : Global / Mandates / Collections -->
              <b-button-group class="mt-2 mt-sm-0">
                <b-button class="px-4" :variant="tabName === 0 ? 'primary btn-selected' : ''" @click="tabName = 0;">{{
                  $t('settings.global_label') }}</b-button>
                <b-button class="px-4" v-if="canSeeMandate" :variant="tabName === 1 ? 'primary btn-selected' : ''"
                  @click="tabName = 1;">{{ $t('settings.mandate_label') }}</b-button>
                <b-button class="px-4" v-if="canSeeCollection" :variant="tabName === 2 ? 'primary btn-selected' : ''"
                  @click="tabName = 2;">{{ $t('settings.collection_label') }}</b-button>
                <b-button v-if="canSeeSRTP" :variant="tabName === 3 ? 'primary' : ''"
                  @click="tabName = 3; resetSettings()">{{ $t('settings.eba_label') }}</b-button>
                <b-button v-if="canSeeHRTP" :variant="tabName === 4 ? 'primary' : ''"
                  @click="tabName = 4; resetSettings()">{{ $t('settings.giro_label') }}</b-button>
                <b-button v-if="canSeePSD2" :variant="tabName === 5 ? 'primary' : ''"
                  @click="tabName = 5; resetSettings()">{{ $t('common.norm.psd2') }}</b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </div>
        <b-tabs v-model="tabName" class="mt-3" nav-class="d-none">
          <!--GENERAL SETTINGS-->
          <b-tab>
            <b-row>
              <b-col cols="12" class="mb-3 mt-3">
                <form-write-group-label-input v-model="settings['NbMaxDowloadData']" :disabled="!doesEdit"
                  :key="'maxLine' + resetInput" :maxLength="21" inputType="number"
                  :inputLabel="$t('settings.max_lines_export')" horizontal>
                </form-write-group-label-input>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <form-accordion :title="$t('settings.mandates_archive')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="justify-content-around d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_archive_freq') }}</label>
                    <div class="d-flex col-7">
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.year') }}</label>
                        <select v-model="sddMandateArchiveFrequenceYear" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 11" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.month') }}</label>
                        <select v-model="sddMandateArchiveFrequenceMonth" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 12" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.day') }}</label>
                        <select v-model="sddMandateArchiveFrequenceDay" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 31" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="justify-content-around d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_archive_delay') }}</label>
                    <div class="d-flex col-7">
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.year') }}</label>
                        <select v-model="sddMandateArchiveDelayYear" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 11" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.month') }}</label>
                        <select v-model="sddMandateArchiveDelayMonth" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 12" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.day') }}</label>
                        <select v-model="sddMandateArchiveDelayDay" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 31" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_last_archive') }}</label>
                    <div class="col-7">
                      <span>{{ sddMandateLastArchive ? sddMandateLastArchive.substring(0, 10) : '' }}</span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.mandates_purge')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="justify-content-around d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_purge_freq') }}</label>
                    <div class="d-flex col-7">
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.year') }}</label>
                        <select v-model="sddMandatePurgeFrequenceYear" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 11" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.month') }}</label>
                        <select v-model="sddMandatePurgeFrequenceMonth" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 12" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.day') }}</label>
                        <select v-model="sddMandatePurgeFrequenceDay" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 31" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="justify-content-around d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_purge_delay') }}</label>
                    <div class="d-flex col-7">
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.year') }}</label>
                        <select v-model="sddMandatePurgeDelayYear" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 11" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.month') }}</label>
                        <select v-model="sddMandatePurgeDelayMonth" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 12" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.day') }}</label>
                        <select v-model="sddMandatePurgeDelayDay" :disabled="!doesEdit" class="form-control sdd-select">
                          <option v-for="n in 31" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_last_purge') }}</label>
                    <div class="col-7">
                      <span>{{ sddMandateLastPurge ? sddMandateLastPurge.substring(0, 10) : '' }}</span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </form-accordion>
          </b-tab>
          <b-tab>
            <form-accordion :title="$t('settings.collection_archive')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="justify-content-around d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_archive_freq') }}</label>
                    <div class="d-flex col-7">
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.year') }}</label>
                        <select v-model="sddCollectionArchiveFrequenceYear" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 11" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2"> 
                        <label>{{ $t('common.month') }}</label>
                        <select v-model="sddCollectionArchiveFrequenceMonth" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 12" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.day') }}</label>
                        <select v-model="sddCollectionArchiveFrequenceDay" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 31" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="justify-content-around d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_archive_delay') }}</label>
                    <div class="d-flex col-7">
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.year') }}</label>
                        <select v-model="sddCollectionArchiveDelayYear" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 11" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.month') }}</label>
                        <select v-model="sddCollectionArchiveDelayMonth" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 12" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.day') }}</label>
                        <select v-model="sddCollectionArchiveDelayDay" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 31" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_last_archive') }}</label>
                    <div class="col-7">
                      <span>{{ sddCollectionLastArchive ? sddCollectionLastArchive.substring(0, 10) : '' }}</span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </form-accordion>
            <form-accordion :title="$t('settings.collection_purge')" class="ml-2" :isTitleUpperCase="false">
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="justify-content-around d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_purge_freq') }}</label>
                    <div class="d-flex col-7">
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.year') }}</label>
                        <select v-model="sddCollectionPurgeFrequenceYear" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 11" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.month') }}</label>
                        <select v-model="sddCollectionPurgeFrequenceMonth" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 12" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.day') }}</label>
                        <select v-model="sddCollectionPurgeFrequenceDay" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 31" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="justify-content-around d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_purge_delay') }}</label>
                    <div class="d-flex col-7">
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.year') }}</label>
                        <select v-model="sddCollectionPurgeDelayYear" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 11" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.month') }}</label>
                        <select v-model="sddCollectionPurgeDelayMonth" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 12" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                      <div class="justify-content-around mr-2">
                        <label>{{ $t('common.day') }}</label>
                        <select v-model="sddCollectionPurgeDelayDay" :disabled="!doesEdit"
                          class="form-control sdd-select">
                          <option v-for="n in 31" :key="n - 1" :value="String(n - 1)">{{ n - 1 }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="mb-4 ml-4">
                  <div class="d-flex justify-content-between align-items-center">
                    <label class="col-5 d-flex align-items-center sdd-label-main">{{ $t('settings.sdd_last_purge') }}</label>
                    <div class="col-7">
                      <span>{{ sddCollectionLastPurge ? sddCollectionLastPurge.substring(0, 10) : '' }}</span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </form-accordion>
          </b-tab>
        </b-tabs>
      </div>
      <div class="col-md-10 offset-md-1" v-if="true">
        <b-row class="justify-content-end no-gutters">
          <div v-if="doesEdit" class="pr-2">
            <b-button @click="resetSettings" variant="primary">
              <span>{{ $t("common.cncl") }}</span>
            </b-button>
          </div>
          <div>
            <b-button v-if="!doesEdit" @click="editSettings" variant="primary">
              <span>{{ $t("administration.edit") }}</span>
            </b-button>
            <b-button v-if="doesEdit" @click="updateSettings(settings)" variant="primary">
              <span>{{ $t("common.update") }}</span>
            </b-button>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
import moment from 'moment'
import PageOutline from "@/components/common/PageOutline.vue"
import FormAccordion from "@/components/common/FormAccordion.vue"
import Spinner from "@/components/common/spinner.vue"
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import formReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue"
import { errorMessageAlert } from '@/helpers/alert'
import { loadPage } from '@/helpers/routing'
import { formatDateTime } from '@/helpers/format'

export default {
  name: "SDDSettings",
  components: {
    "page-outline": PageOutline,
    "form-accordion": FormAccordion,
    spinner: Spinner,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "form-read-group-label-input": formReadGroupLabelInput,
  },
  data() {
    return {
      activateSpinner: false,
      comaCount: 0,
      doesEdit: false,
      environnments: {},
      originalSettings: {},
      resetInput: false,
      settings: {
        // Anciennes clés RTP supprimées voir RTPSettings.vue si besoin VLE
        'NbMaxDowloadData': '',
        'Mandate-ArchiveFrequence': '',
        'Mandate-ArchiveDelay': '',
        'Mandate-LastArchive': '',
        'Mandate-PurgeFrequence': '',
        'Mandate-PurgeDelay': '',
        'Mandate-LastPurge': '',
        'Collection-ArchiveFrequence': '',
        'Collection-ArchiveDelay': '',
        'Collection-LastArchive': '',
        'Collection-PurgeFrequence': '',
        'Collection-PurgeDelay': '',
        'Collection-LastPurge': '',
        // Core
        'NbMaxDowloadData_CORE': '',
        'Mandate-ArchiveFrequence_CORE': '',
        'Mandate-ArchiveDelay_CORE': '',
        'Mandate-LastArchive_CORE': '',
        'Mandate-PurgeFrequence_CORE': '',
        'Mandate-PurgeDelay_CORE': '',
        'Mandate-LastPurge_CORE': '',
        'Collection-ArchiveFrequence_CORE': '',
        'Collection-ArchiveDelay_CORE': '',
        'Collection-LastArchive_CORE': '',
        'Collection-PurgeFrequence_CORE': '',
        'Collection-PurgeDelay_CORE': '',
        'Collection-LastPurge_CORE': '',
        // B2B
        'NbMaxDowloadData_B2B': '',
        'Mandate-ArchiveFrequence_B2B': '',
        'Mandate-ArchiveDelay_B2B': '',
        'Mandate-LastArchive_B2B': '',
        'Mandate-PurgeFrequence_B2B': '',
        'Mandate-PurgeDelay_B2B': '',
        'Mandate-LastPurge_B2B': '',
        'Collection-ArchiveFrequence_B2B': '',
        'Collection-ArchiveDelay_B2B': '',
        'Collection-LastArchive_B2B': '',
        'Collection-PurgeFrequence_B2B': '',
        'Collection-PurgeDelay_B2B': '',
        'Collection-LastPurge_B2B': '',
      },
      tabName: 0,
      superTab: 'global',
    }
  },
  computed: {
    suffix() {
      if (this.superTab === 'core') return '_CORE'
      if (this.superTab === 'b2b') return '_B2B'
      return ''
    },
    canSeeCollection() {
      return true
    },
    canSeeMandate() {
      return true
    },
    canSeeSRTP() {
      if (this.$engine.rights.rightIs('super_admin', true)) {
        return true
      } else if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '1' && this.$engine.rights.rightIs('rtp_norm_srtp', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_srtp', true)
      }
    },
    canSeeHRTP() {
      if (this.$engine.rights.rightIs('super_admin', true)) {
        return true
      } else if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '2' && this.$engine.rights.rightIs('rtp_norm_hrtp', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_hrtp', true)
      }
    },
    canSeePSD2() {
      if (this.$engine.rights.rightIs('super_admin', true)) {
        return true
      } else if (this.$engine.user.getUserNorm()) {
        return this.$engine.user.getUserNorm() === '3' && this.$engine.rights.rightIs('rtp_norm_psd2', true)
      } else {
        return this.$engine.rights.rightIs('rtp_norm_psd2', true)
      }
    },
    /*hrtpArchiveDelayYear: {
      get() {
        return this.settings['HRTP-ArchiveDelay'] ? this.settings['HRTP-ArchiveDelay'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['HRTP-ArchiveDelay'] ? this.originalSettings['HRTP-ArchiveDelay'].split(',')[0] : '0'
        }
        if (this.settings['HRTP-ArchiveDelay']) {
          this.settings['HRTP-ArchiveDelay'] = newYear + ',' + this.hrtpArchiveDelayMonth + ',' + this.hrtpArchiveDelayDay
        } else {
          this.settings['HRTP-ArchiveDelay'] = newYear + ',0,0'
        }
      }
    },
    hrtpArchiveDelayMonth: {
      get() {
        return this.settings['HRTP-ArchiveDelay'] ? this.settings['HRTP-ArchiveDelay'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['HRTP-ArchiveDelay'] ? this.originalSettings['HRTP-ArchiveDelay'].split(',')[1] : '0'
        }
        if (this.settings['HRTP-ArchiveDelay']) {
          this.settings['HRTP-ArchiveDelay'] = this.hrtpArchiveDelayYear + ',' + newMonth + ',' + this.hrtpArchiveDelayDay
        } else {
          this.settings['HRTP-ArchiveDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    hrtpArchiveDelayDay: {
      get() {
        return this.settings['HRTP-ArchiveDelay'] ? this.settings['HRTP-ArchiveDelay'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['HRTP-ArchiveDelay'] ? this.originalSettings['HRTP-ArchiveDelay'].split(',')[2] : '0'
        }
        if (this.settings['HRTP-ArchiveDelay']) {
          this.settings['HRTP-ArchiveDelay'] = this.hrtpArchiveDelayYear + ',' + this.hrtpArchiveDelayMonth + ',' + newDay
        } else {
          this.settings['HRTP-ArchiveDelay'] = '0,0,' + newDay
        }
      }
    },
    hrtpArchiveFrequenceYear: {
      get() {
        return this.settings['HRTP-ArchiveFrequence'] ? this.settings['HRTP-ArchiveFrequence'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['HRTP-ArchiveFrequence'] ? this.originalSettings['HRTP-ArchiveFrequence'].split(',')[0] : '0'
        }
        if (this.settings['HRTP-ArchiveFrequence']) {
          this.settings['HRTP-ArchiveFrequence'] = newYear + ',' + this.hrtpArchiveFrequenceMonth + ',' + this.hrtpArchiveFrequenceDay
        } else {
          this.settings['HRTP-ArchiveFrequence'] = newYear + ',0,0'
        }
      }
    },
    hrtpArchiveFrequenceMonth: {
      get() {
        return this.settings['HRTP-ArchiveFrequence'] ? this.settings['HRTP-ArchiveFrequence'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['HRTP-ArchiveFrequence'] ? this.originalSettings['HRTP-ArchiveFrequence'].split(',')[1] : '0'
        }
        if (this.settings['HRTP-ArchiveFrequence']) {
          this.settings['HRTP-ArchiveFrequence'] = this.hrtpArchiveFrequenceYear + ',' + newMonth + ',' + this.hrtpArchiveFrequenceDay
        } else {
          this.settings['HRTP-ArchiveFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    hrtpArchiveFrequenceDay: {
      get() {
        return this.settings['HRTP-ArchiveFrequence'] ? this.settings['HRTP-ArchiveFrequence'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['HRTP-ArchiveFrequence'] ? this.originalSettings['HRTP-ArchiveFrequence'].split(',')[1] : '0'
        }
        if (this.settings['HRTP-ArchiveFrequence']) {
          this.settings['HRTP-ArchiveFrequence'] = this.hrtpArchiveFrequenceYear + ',' + this.hrtpArchiveFrequenceMonth + ',' + newDay
        } else {
          this.settings['HRTP-ArchiveFrequence'] = '0,0,' + newDay
        }
      }
    },
    hrtpLastArchive() {
      return this.$options.filters.formatDateTime(this.settings.HRTP_LastArchive)
    },
    hrtpLastPurge() {
      return this.$options.filters.formatDateTime(this.settings.HRTP_LastPurge)
    },
    hrtpPurgeDelayYear: {
      get() {
        return this.settings['HRTP-PurgeDelay'] ? this.settings['HRTP-PurgeDelay'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['HRTP-PurgeDelay'] ? this.originalSettings['HRTP-PurgeDelay'].split(',')[0] : '0'
        }
        if (this.settings['HRTP-PurgeDelay']) {
          this.settings['HRTP-PurgeDelay'] = newYear + ',' + this.hrtpPurgeDelayMonth + ',' + this.hrtpPurgeDelayDay
        } else {
          this.settings['HRTP-PurgeDelay'] = newYear + ',0,0'
        }
      }
    },
    hrtpPurgeDelayMonth: {
      get() {
        return this.settings['HRTP-PurgeDelay'] ? this.settings['HRTP-PurgeDelay'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['HRTP-PurgeDelay'] ? this.originalSettings['HRTP-PurgeDelay'].split(',')[1] : '0'
        }
        if (this.settings['HRTP-PurgeDelay']) {
          this.settings['HRTP-PurgeDelay'] = this.hrtpPurgeDelayYear + ',' + newMonth + ',' + this.hrtpPurgeDelayDay
        } else {
          this.settings['HRTP-PurgeDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    hrtpPurgeDelayDay: {
      get() {
        return this.settings['HRTP-PurgeDelay'] ? this.settings['HRTP-PurgeDelay'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['HRTP-PurgeDelay'] ? this.originalSettings['HRTP-PurgeDelay'].split(',')[2] : '0'
        }
        if (this.settings['HRTP-PurgeDelay']) {
          this.settings['HRTP-PurgeDelay'] = this.hrtpPurgeDelayYear + ',' + this.hrtpPurgeDelayMonth + ',' + newDay
        } else {
          this.settings['HRTP-PurgeDelay'] = '0,0,' + newDay
        }
      }
    },
    hrtpPurgeFrequenceYear: {
      get() {
        return this.settings['HRTP-PurgeFrequence'] ? this.settings['HRTP-PurgeFrequence'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['HRTP-PurgeFrequence'] ? this.originalSettings['HRTP-PurgeFrequence'].split(',')[0] : '0'
        }
        if (this.settings['HRTP-PurgeFrequence']) {
          this.settings['HRTP-PurgeFrequence'] = newYear + ',' + this.hrtpPurgeFrequenceMonth + ',' + this.hrtpPurgeFrequenceDay
        } else {
          this.settings['HRTP-PurgeFrequence'] = newYear + ',0,0'
        }
      }
    },
    hrtpPurgeFrequenceMonth: {
      get() {
        return this.settings['HRTP-PurgeFrequence'] ? this.settings['HRTP-PurgeFrequence'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['HRTP-PurgeFrequence'] ? this.originalSettings['HRTP-PurgeFrequence'].split(',')[1] : '0'
        }
        if (this.settings['HRTP-PurgeFrequence']) {
          this.settings['HRTP-PurgeFrequence'] = this.hrtpPurgeFrequenceYear + ',' + newMonth + ',' + this.hrtpPurgeFrequenceDay
        } else {
          this.settings['HRTP-PurgeFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    hrtpPurgeFrequenceDay: {
      get() {
        return this.settings['HRTP-PurgeFrequence'] ? this.settings['HRTP-PurgeFrequence'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['HRTP-PurgeFrequence'] ? this.originalSettings['HRTP-PurgeFrequence'].split(',')[2] : '0'
        }
        if (this.settings['HRTP-PurgeFrequence']) {
          this.settings['HRTP-PurgeFrequence'] = this.hrtpPurgeFrequenceYear + ',' + this.hrtpPurgeFrequenceMonth + ',' + newDay
        } else {
          this.settings['HRTP-PurgeFrequence'] = '0,0,' + newDay
        }
      }
    },
    psd2ArchiveDelayYear: {
      get() {
        return this.settings['PSD2-ArchiveDelay'] ? this.settings['PSD2-ArchiveDelay'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['PSD2-ArchiveDelay'] ? this.originalSettings['PSD2-ArchiveDelay'].split(',')[0] : '0'
        }
        if (this.settings['PSD2-ArchiveDelay']) {
          this.settings['PSD2-ArchiveDelay'] = newYear + ',' + this.psd2ArchiveDelayMonth + ',' + this.psd2ArchiveDelayDay
        } else {
          this.settings['PSD2-ArchiveDelay'] = newYear + ',0,0'
        }
      }
    },
    psd2ArchiveDelayMonth: {
      get() {
        return this.settings['PSD2-ArchiveDelay'] ? this.settings['PSD2-ArchiveDelay'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['PSD2-ArchiveDelay'] ? this.originalSettings['PSD2-ArchiveDelay'].split(',')[1] : '0'
        }
        if (this.settings['PSD2-ArchiveDelay']) {
          this.settings['PSD2-ArchiveDelay'] = this.psd2ArchiveDelayYear + ',' + newMonth + ',' + this.psd2ArchiveDelayDay
        } else {
          this.settings['PSD2-ArchiveDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    psd2ArchiveDelayDay: {
      get() {
        return this.settings['PSD2-ArchiveDelay'] ? this.settings['PSD2-ArchiveDelay'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['PSD2-ArchiveDelay'] ? this.originalSettings['PSD2-ArchiveDelay'].split(',')[2] : '0'
        }
        if (this.settings['PSD2-ArchiveDelay']) {
          this.settings['PSD2-ArchiveDelay'] = this.psd2ArchiveDelayYear + ',' + this.psd2ArchiveDelayMonth + ',' + newDay
        } else {
          this.settings['PSD2-ArchiveDelay'] = '0,0,' + newDay
        }
      }
    },
    psd2ArchiveFrequenceYear: {
      get() {
        return this.settings['PSD2-ArchiveFrequence'] ? this.settings['PSD2-ArchiveFrequence'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['PSD2-ArchiveFrequence'] ? this.originalSettings['PSD2-ArchiveFrequence'].split(',')[0] : '0'
        }
        if (this.settings['PSD2-ArchiveFrequence']) {
          this.settings['PSD2-ArchiveFrequence'] = newYear + ',' + this.psd2ArchiveFrequenceMonth + ',' + this.psd2ArchiveFrequenceDay
        } else {
          this.settings['PSD2-ArchiveFrequence'] = newYear + ',0,0'
        }
      }
    },
    psd2ArchiveFrequenceMonth: {
      get() {
        return this.settings['PSD2-ArchiveFrequence'] ? this.settings['PSD2-ArchiveFrequence'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['PSD2-ArchiveFrequence'] ? this.originalSettings['PSD2-ArchiveFrequence'].split(',')[1] : '0'
        }
        if (this.settings['PSD2-ArchiveFrequence']) {
          this.settings['PSD2-ArchiveFrequence'] = this.psd2ArchiveFrequenceYear + ',' + newMonth + ',' + this.psd2ArchiveFrequenceDay
        } else {
          this.settings['PSD2-ArchiveFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    psd2ArchiveFrequenceDay: {
      get() {
        return this.settings['PSD2-ArchiveFrequence'] ? this.settings['PSD2-ArchiveFrequence'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['PSD2-ArchiveFrequence'] ? this.originalSettings['PSD2-ArchiveFrequence'].split(',')[1] : '0'
        }
        if (this.settings['PSD2-ArchiveFrequence']) {
          this.settings['PSD2-ArchiveFrequence'] = this.psd2ArchiveFrequenceYear + ',' + this.psd2ArchiveFrequenceMonth + ',' + newDay
        } else {
          this.settings['PSD2-ArchiveFrequence'] = '0,0,' + newDay
        }
      }
    },
    psd2LastArchive() {
      return this.$options.filters.formatDateTime(this.settings.PSD2_LastArchive)
    },
    psd2LastPurge() {
      return this.$options.filters.formatDateTime(this.settings.PSD2_LastPurge)
    },
    psd2PurgeDelayYear: {
      get() {
        return this.settings['PSD2-PurgeDelay'] ? this.settings['PSD2-PurgeDelay'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['PSD2-PurgeDelay'] ? this.originalSettings['PSD2-PurgeDelay'].split(',')[0] : '0'
        }
        if (this.settings['PSD2-PurgeDelay']) {
          this.settings['PSD2-PurgeDelay'] = newYear + ',' + this.psd2PurgeDelayMonth + ',' + this.psd2PurgeDelayDay
        } else {
          this.settings['PSD2-PurgeDelay'] = newYear + ',0,0'
        }
      }
    },
    psd2PurgeDelayMonth: {
      get() {
        return this.settings['PSD2-PurgeDelay'] ? this.settings['PSD2-PurgeDelay'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['PSD2-PurgeDelay'] ? this.originalSettings['PSD2-PurgeDelay'].split(',')[1] : '0'
        }
        if (this.settings['PSD2-PurgeDelay']) {
          this.settings['PSD2-PurgeDelay'] = this.psd2PurgeDelayYear + ',' + newMonth + ',' + this.psd2PurgeDelayDay
        } else {
          this.settings['PSD2-PurgeDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    psd2PurgeDelayDay: {
      get() {
        return this.settings['PSD2-PurgeDelay'] ? this.settings['PSD2-PurgeDelay'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['PSD2-PurgeDelay'] ? this.originalSettings['PSD2-PurgeDelay'].split(',')[2] : '0'
        }
        if (this.settings['PSD2-PurgeDelay']) {
          this.settings['PSD2-PurgeDelay'] = this.psd2PurgeDelayYear + ',' + this.psd2PurgeDelayMonth + ',' + newDay
        } else {
          this.settings['PSD2-PurgeDelay'] = '0,0,' + newDay
        }
      }
    },
    psd2PurgeFrequenceYear: {
      get() {
        return this.settings['PSD2-PurgeFrequence'] ? this.settings['PSD2-PurgeFrequence'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['PSD2-PurgeFrequence'] ? this.originalSettings['PSD2-PurgeFrequence'].split(',')[0] : '0'
        }
        if (this.settings['PSD2-PurgeFrequence']) {
          this.settings['PSD2-PurgeFrequence'] = newYear + ',' + this.psd2PurgeFrequenceMonth + ',' + this.psd2PurgeFrequenceDay
        } else {
          this.settings['PSD2-PurgeFrequence'] = newYear + ',0,0'
        }
      }
    },
    psd2PurgeFrequenceMonth: {
      get() {
        return this.settings['PSD2-PurgeFrequence'] ? this.settings['PSD2-PurgeFrequence'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['PSD2-PurgeFrequence'] ? this.originalSettings['PSD2-PurgeFrequence'].split(',')[1] : '0'
        }
        if (this.settings['PSD2-PurgeFrequence']) {
          this.settings['PSD2-PurgeFrequence'] = this.psd2PurgeFrequenceYear + ',' + newMonth + ',' + this.psd2PurgeFrequenceDay
        } else {
          this.settings['PSD2-PurgeFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    psd2PurgeFrequenceDay: {
      get() {
        return this.settings['PSD2-PurgeFrequence'] ? this.settings['PSD2-PurgeFrequence'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['PSD2-PurgeFrequence'] ? this.originalSettings['PSD2-PurgeFrequence'].split(',')[2] : '0'
        }
        if (this.settings['PSD2-PurgeFrequence']) {
          this.settings['PSD2-PurgeFrequence'] = this.psd2PurgeFrequenceYear + ',' + this.psd2PurgeFrequenceMonth + ',' + newDay
        } else {
          this.settings['PSD2-PurgeFrequence'] = '0,0,' + newDay
        }
      }
    },
    sddArchiveDelayYear: {
      get() {
        return this.settings['SDD-ArchiveDelay'] ? this.settings['SDD-ArchiveDelay'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['SDD-ArchiveDelay'] ? this.originalSettings['SDD-ArchiveDelay'].split(',')[0] : '0'
        }
        if (this.settings['SDD-ArchiveDelay']) {
          this.settings['SDD-ArchiveDelay'] = newYear + ',' + this.sddArchiveDelayMonth + ',' + this.sddArchiveDelayDay
        } else {
          this.settings['SDD-ArchiveDelay'] = newYear + ',0,0'
        }
      }
    },
    sddArchiveDelayMonth: {
      get() {
        return this.settings['SDD-ArchiveDelay'] ? this.settings['SDD-ArchiveDelay'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['SDD-ArchiveDelay'] ? this.originalSettings['SDD-ArchiveDelay'].split(',')[1] : '0'
        }
        if (this.settings['SDD-ArchiveDelay']) {
          this.settings['SDD-ArchiveDelay'] = this.sddArchiveDelayYear + ',' + newMonth + ',' + this.sddArchiveDelayDay
        } else {
          this.settings['SDD-ArchiveDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    sddArchiveDelayDay: {
      get() {
        return this.settings['SDD-ArchiveDelay'] ? this.settings['SDD-ArchiveDelay'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['SDD-ArchiveDelay'] ? this.originalSettings['SDD-ArchiveDelay'].split(',')[2] : '0'
        }
        if (this.settings['SDD-ArchiveDelay']) {
          this.settings['SDD-ArchiveDelay'] = this.sddArchiveDelayYear + ',' + this.sddArchiveDelayMonth + ',' + newDay
        } else {
          this.settings['SDD-ArchiveDelay'] = '0,0,' + newDay
        }
      }
    },
    sddArchiveFrequenceYear: {
      get() {
        return this.settings['SDD-ArchiveFrequence'] ? this.settings['SDD-ArchiveFrequence'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['SDD-ArchiveFrequence'] ? this.originalSettings['SDD-ArchiveFrequence'].split(',')[0] : '0'
        }
        if (this.settings['SDD-ArchiveFrequence']) {
          this.settings['SDD-ArchiveFrequence'] = newYear + ',' + this.sddArchiveFrequenceMonth + ',' + this.sddArchiveFrequenceDay
        } else {
          this.settings['SDD-ArchiveFrequence'] = newYear + ',0,0'
        }
      }
    },
    sddArchiveFrequenceMonth: {
      get() {
        return this.settings['SDD-ArchiveFrequence'] ? this.settings['SDD-ArchiveFrequence'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['SDD-ArchiveFrequence'] ? this.originalSettings['SDD-ArchiveFrequence'].split(',')[1] : '0'
        }
        if (this.settings['SDD-ArchiveFrequence']) {
          this.settings['SDD-ArchiveFrequence'] = this.sddArchiveFrequenceYear + ',' + newMonth + ',' + this.sddArchiveFrequenceDay
        } else {
          this.settings['SDD-ArchiveFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    sddArchiveFrequenceDay: {
      get() {
        return this.settings['SDD-ArchiveFrequence'] ? this.settings['SDD-ArchiveFrequence'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['SDD-ArchiveFrequence'] ? this.originalSettings['SDD-ArchiveFrequence'].split(',')[2] : '0'
        }
        if (this.settings['SDD-ArchiveFrequence']) {
          this.settings['SDD-ArchiveFrequence'] = this.sddArchiveFrequenceYear + ',' + this.sddArchiveFrequenceMonth + ',' + newDay
        } else {
          this.settings['SDD-ArchiveFrequence'] = '0,0,' + newDay
        }
      }
    },
    */
    sddCollectionArchiveDelayYear: {
      get() {
        return this.settings['Collection-ArchiveDelay' + this.suffix] ? this.settings['Collection-ArchiveDelay' + this.suffix].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') { this.resetInput = !this.resetInput; newYear = this.originalSettings['Collection-ArchiveDelay' + this.suffix]?.split(',')[0] || '0' }
        this.settings['Collection-ArchiveDelay' + this.suffix] = newYear + ',' + this.sddCollectionArchiveDelayMonth + ',' + this.sddCollectionArchiveDelayDay
      },
    },
    sddCollectionArchiveDelayMonth: {
      get() {
        return this.settings['Collection-ArchiveDelay' + this.suffix] ? this.settings['Collection-ArchiveDelay' + this.suffix].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') { this.resetInput = !this.resetInput; newMonth = this.originalSettings['Collection-ArchiveDelay' + this.suffix]?.split(',')[1] || '0' }
        this.settings['Collection-ArchiveDelay' + this.suffix] = this.sddCollectionArchiveDelayYear + ',' + newMonth + ',' + this.sddCollectionArchiveDelayDay
      }
    },
    sddCollectionArchiveDelayDay: {
      get() {
        return this.settings['Collection-ArchiveDelay' + this.suffix] ? this.settings['Collection-ArchiveDelay' + this.suffix].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') { this.resetInput = !this.resetInput; newDay = this.originalSettings['Collection-ArchiveDelay' + this.suffix]?.split(',')[2] || '0' }
        this.settings['Collection-ArchiveDelay' + this.suffix] = this.sddCollectionArchiveDelayYear + ',' + this.sddCollectionArchiveDelayMonth + ',' + newDay
      },
    },
    sddCollectionArchiveFrequenceYear: {
      get() {
        return this.settings['Collection-ArchiveFrequence' + this.suffix] ? this.settings['Collection-ArchiveFrequence' + this.suffix].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') { this.resetInput = !this.resetInput; newYear = this.originalSettings['Collection-ArchiveFrequence' + this.suffix]?.split(',')[0] || '0' }
        this.settings['Collection-ArchiveFrequence' + this.suffix] = newYear + ',' + this.sddCollectionArchiveFrequenceMonth + ',' + this.sddCollectionArchiveFrequenceDay
      }
    },
    sddCollectionArchiveFrequenceMonth: {
      get() {
        return this.settings['Collection-ArchiveFrequence' + this.suffix] ? this.settings['Collection-ArchiveFrequence' + this.suffix].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') { this.resetInput = !this.resetInput; newMonth = this.originalSettings['Collection-ArchiveFrequence' + this.suffix]?.split(',')[1] || '0' }
        this.settings['Collection-ArchiveFrequence' + this.suffix] = this.sddCollectionArchiveFrequenceYear + ',' + newMonth + ',' + this.sddCollectionArchiveFrequenceDay
      }
    },
    sddCollectionArchiveFrequenceDay: {
      get() {
        return this.settings['Collection-ArchiveFrequence' + this.suffix] ? this.settings['Collection-ArchiveFrequence' + this.suffix].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') { this.resetInput = !this.resetInput; newDay = this.originalSettings['Collection-ArchiveFrequence' + this.suffix]?.split(',')[2] || '0' }
        this.settings['Collection-ArchiveFrequence' + this.suffix] = this.sddCollectionArchiveFrequenceYear + ',' + this.sddCollectionArchiveFrequenceMonth + ',' + newDay
      },
    },
    sddCollectionLastArchive() {
      return this.settings['Collection-LastArchive' + this.suffix]
    },
    sddCollectionLastPurge() {
      return this.settings['Collection-LastPurge' + this.suffix]
    },
    sddCollectionPurgeDelayYear: {
      get() {
        return this.settings['Collection-PurgeDelay' + this.suffix] ? this.settings['Collection-PurgeDelay' + this.suffix].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') { this.resetInput = !this.resetInput; newYear = this.originalSettings['Collection-PurgeDelay' + this.suffix]?.split(',')[0] || '0' }
        this.settings['Collection-PurgeDelay' + this.suffix] = newYear + ',' + this.sddCollectionPurgeDelayMonth + ',' + this.sddCollectionPurgeDelayDay
      }

    },
    sddCollectionPurgeDelayMonth: {
      get() {
        return this.settings['Collection-PurgeDelay' + this.suffix] ? this.settings['Collection-PurgeDelay' + this.suffix].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') { this.resetInput = !this.resetInput; newMonth = this.originalSettings['Collection-PurgeDelay' + this.suffix]?.split(',')[1] || '0' }
        this.settings['Collection-PurgeDelay' + this.suffix] = this.sddCollectionPurgeDelayYear + ',' + newMonth + ',' + this.sddCollectionPurgeDelayDay
      }
    },
    sddCollectionPurgeDelayDay: {
      get() {
        return this.settings['Collection-PurgeDelay' + this.suffix] ? this.settings['Collection-PurgeDelay' + this.suffix].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') { this.resetInput = !this.resetInput; newDay = this.originalSettings['Collection-PurgeDelay' + this.suffix]?.split(',')[2] || '0' }
        this.settings['Collection-PurgeDelay' + this.suffix] = this.sddCollectionPurgeDelayYear + ',' + this.sddCollectionPurgeDelayMonth + ',' + newDay
      },
    },
    sddCollectionPurgeFrequenceYear: {
      get() {
        return this.settings['Collection-PurgeFrequence' + this.suffix] ? this.settings['Collection-PurgeFrequence' + this.suffix].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') { this.resetInput = !this.resetInput; newYear = this.originalSettings['Collection-PurgeFrequence' + this.suffix]?.split(',')[0] || '0' }
        this.settings['Collection-PurgeFrequence' + this.suffix] = newYear + ',' + this.sddCollectionPurgeFrequenceMonth + ',' + this.sddCollectionPurgeFrequenceDay
      },
    },
    sddCollectionPurgeFrequenceMonth: {
      get() {
        return this.settings['Collection-PurgeFrequence' + this.suffix] ? this.settings['Collection-PurgeFrequence' + this.suffix].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') { this.resetInput = !this.resetInput; newMonth = this.originalSettings['Collection-PurgeFrequence' + this.suffix]?.split(',')[1] || '0' }
        this.settings['Collection-PurgeFrequence' + this.suffix] = this.sddCollectionPurgeFrequenceYear + ',' + newMonth + ',' + this.sddCollectionPurgeFrequenceDay
      }
    },
    sddCollectionPurgeFrequenceDay: {
      get() {
        return this.settings['Collection-PurgeFrequence' + this.suffix] ? this.settings['Collection-PurgeFrequence' + this.suffix].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') { this.resetInput = !this.resetInput; newDay = this.originalSettings['Collection-PurgeFrequence' + this.suffix]?.split(',')[2] || '0' }
        this.settings['Collection-PurgeFrequence' + this.suffix] = this.sddCollectionPurgeFrequenceYear + ',' + this.sddCollectionPurgeFrequenceMonth + ',' + newDay
      },
    },
    sddMandateArchiveDelayYear: {
      get() {
        return this.settings['Mandate-ArchiveDelay' + this.suffix] ? this.settings['Mandate-ArchiveDelay' + this.suffix].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') { this.resetInput = !this.resetInput; newYear = this.originalSettings['Mandate-ArchiveDelay' + this.suffix]?.split(',')[0] || '0' }
        this.settings['Mandate-ArchiveDelay' + this.suffix] = newYear + ',' + this.sddMandateArchiveDelayMonth + ',' + this.sddMandateArchiveDelayDay
      }
    },
    sddMandateArchiveDelayMonth: {
      get() {
        return this.settings['Mandate-ArchiveDelay' + this.suffix] ? this.settings['Mandate-ArchiveDelay' + this.suffix].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') { this.resetInput = !this.resetInput; newMonth = this.originalSettings['Mandate-ArchiveDelay' + this.suffix]?.split(',')[1] || '0' }
        this.settings['Mandate-ArchiveDelay' + this.suffix] = this.sddMandateArchiveDelayYear + ',' + newMonth + ',' + this.sddMandateArchiveDelayDay
      },
    },
    sddMandateArchiveDelayDay: {
      get() {
        return this.settings['Mandate-ArchiveDelay' + this.suffix] ? this.settings['Mandate-ArchiveDelay' + this.suffix].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') { this.resetInput = !this.resetInput; newDay = this.originalSettings['Mandate-ArchiveDelay' + this.suffix]?.split(',')[2] || '0' }
        this.settings['Mandate-ArchiveDelay' + this.suffix] = this.sddMandateArchiveDelayYear + ',' + this.sddMandateArchiveDelayMonth + ',' + newDay
      }
    },
    sddMandateArchiveFrequenceYear: {
      get() {
        return this.settings['Mandate-ArchiveFrequence' + this.suffix] ? this.settings['Mandate-ArchiveFrequence' + this.suffix].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['Mandate-ArchiveFrequence' + this.suffix]?.split(',')[0] || '0'
        }
        const m = this.sddMandateArchiveFrequenceMonth
        const d = this.sddMandateArchiveFrequenceDay
        this.settings['Mandate-ArchiveFrequence' + this.suffix] = newYear + ',' + m + ',' + d
      }
    },
    sddMandateArchiveFrequenceMonth: {
      get() {
        return this.settings['Mandate-ArchiveFrequence' + this.suffix] ? this.settings['Mandate-ArchiveFrequence' + this.suffix].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') { this.resetInput = !this.resetInput; newMonth = this.originalSettings['Mandate-ArchiveFrequence' + this.suffix]?.split(',')[1] || '0' }
        this.settings['Mandate-ArchiveFrequence' + this.suffix] = this.sddMandateArchiveFrequenceYear + ',' + newMonth + ',' + this.sddMandateArchiveFrequenceDay
      }
    },

    sddMandateArchiveFrequenceDay: {
      get() {
        return this.settings['Mandate-ArchiveFrequence' + this.suffix] ? this.settings['Mandate-ArchiveFrequence' + this.suffix].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') { this.resetInput = !this.resetInput; newDay = this.originalSettings['Mandate-ArchiveFrequence' + this.suffix]?.split(',')[2] || '0' }
        this.settings['Mandate-ArchiveFrequence' + this.suffix] = this.sddMandateArchiveFrequenceYear + ',' + this.sddMandateArchiveFrequenceMonth + ',' + newDay
      }
    },
    sddMandateLastArchive() {
      return this.settings['Mandate-LastArchive' + this.suffix]
    },
    sddMandateLastPurge() {
      return this.settings['Mandate-LastPurge' + this.suffix]
    },
    sddMandatePurgeDelayYear: {
      get() {
        return this.settings['Mandate-PurgeDelay' + this.suffix] ? this.settings['Mandate-PurgeDelay' + this.suffix].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') { this.resetInput = !this.resetInput; newYear = this.originalSettings['Mandate-PurgeDelay' + this.suffix]?.split(',')[0] || '0' }
        this.settings['Mandate-PurgeDelay' + this.suffix] = newYear + ',' + this.sddMandatePurgeDelayMonth + ',' + this.sddMandatePurgeDelayDay
      }
    },
    sddMandatePurgeDelayMonth: {
      get() {
        return this.settings['Mandate-PurgeDelay' + this.suffix] ? this.settings['Mandate-PurgeDelay' + this.suffix].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') { this.resetInput = !this.resetInput; newMonth = this.originalSettings['Mandate-PurgeDelay' + this.suffix]?.split(',')[1] || '0' }
        this.settings['Mandate-PurgeDelay' + this.suffix] = this.sddMandatePurgeDelayYear + ',' + newMonth + ',' + this.sddMandatePurgeDelayDay
      }
    },
    sddMandatePurgeDelayDay: {
      get() {
        return this.settings['Mandate-PurgeDelay' + this.suffix] ? this.settings['Mandate-PurgeDelay' + this.suffix].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') { this.resetInput = !this.resetInput; newDay = this.originalSettings['Mandate-PurgeDelay' + this.suffix]?.split(',')[2] || '0' }
        this.settings['Mandate-PurgeDelay' + this.suffix] = this.sddMandatePurgeDelayYear + ',' + this.sddMandatePurgeDelayMonth + ',' + newDay
      }
    },
    sddMandatePurgeFrequenceYear: {
      get() {
        return this.settings['Mandate-PurgeFrequence' + this.suffix] ? this.settings['Mandate-PurgeFrequence' + this.suffix].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') { this.resetInput = !this.resetInput; newYear = this.originalSettings['Mandate-PurgeFrequence' + this.suffix]?.split(',')[0] || '0' }
        this.settings['Mandate-PurgeFrequence' + this.suffix] = newYear + ',' + this.sddMandatePurgeFrequenceMonth + ',' + this.sddMandatePurgeFrequenceDay
      },
    },
    sddMandatePurgeFrequenceMonth: {
      get() {
        return this.settings['Mandate-PurgeFrequence' + this.suffix] ? this.settings['Mandate-PurgeFrequence' + this.suffix].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') { this.resetInput = !this.resetInput; newMonth = this.originalSettings['Mandate-PurgeFrequence' + this.suffix]?.split(',')[1] || '0' }
        this.settings['Mandate-PurgeFrequence' + this.suffix] = this.sddMandatePurgeFrequenceYear + ',' + newMonth + ',' + this.sddMandatePurgeFrequenceDay
      }
    },
    sddMandatePurgeFrequenceDay: {
      get() {
        return this.settings['Mandate-PurgeFrequence' + this.suffix] ? this.settings['Mandate-PurgeFrequence' + this.suffix].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') { this.resetInput = !this.resetInput; newDay = this.originalSettings['Mandate-PurgeFrequence' + this.suffix]?.split(',')[2] || '0' }
        this.settings['Mandate-PurgeFrequence' + this.suffix] = this.sddMandatePurgeFrequenceYear + ',' + this.sddMandatePurgeFrequenceMonth + ',' + newDay
      }
    },
    srtpArchiveDelayYear: {
      get() {
        return this.settings['SRTP-ArchiveDelay'] ? this.settings['SRTP-ArchiveDelay'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['SRTP-ArchiveDelay'] ? this.originalSettings['SRTP-ArchiveDelay'].split(',')[0] : '0'
        }
        if (this.settings['SRTP-ArchiveDelay']) {
          this.settings['SRTP-ArchiveDelay'] = newYear + ',' + this.srtpArchiveDelayMonth + ',' + this.srtpArchiveDelayDay
        } else {
          this.settings['SRTP-ArchiveDelay'] = newYear + ',0,0'
        }
      }
    },
    srtpArchiveDelayMonth: {
      get() {
        return this.settings['SRTP-ArchiveDelay'] ? this.settings['SRTP-ArchiveDelay'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['SRTP-ArchiveDelay'] ? this.originalSettings['SRTP-ArchiveDelay'].split(',')[1] : '0'
        }
        if (this.settings['SRTP-ArchiveDelay']) {
          this.settings['SRTP-ArchiveDelay'] = this.srtpArchiveDelayYear + ',' + newMonth + ',' + this.srtpArchiveDelayDay
        } else {
          this.settings['SRTP-ArchiveDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    srtpArchiveDelayDay: {
      get() {
        return this.settings['SRTP-ArchiveDelay'] ? this.settings['SRTP-ArchiveDelay'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['SRTP-ArchiveDelay'] ? this.originalSettings['SRTP-ArchiveDelay'].split(',')[2] : '0'
        }
        if (this.settings['SRTP-ArchiveDelay']) {
          this.settings['SRTP-ArchiveDelay'] = this.srtpArchiveDelayYear + ',' + this.srtpArchiveDelayMonth + ',' + newDay
        } else {
          this.settings['SRTP-ArchiveDelay'] = '0,0,' + newDay
        }
      }
    },
    srtpArchiveFrequenceYear: {
      get() {
        return this.settings['SRTP-ArchiveFrequence'] ? this.settings['SRTP-ArchiveFrequence'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['SRTP-ArchiveFrequence'] ? this.originalSettings['SRTP-ArchiveFrequence'].split(',')[0] : '0'
        }
        if (this.settings['SRTP-ArchiveFrequence']) {
          this.settings['SRTP-ArchiveFrequence'] = newYear + ',' + this.srtpArchiveFrequenceMonth + ',' + this.srtpArchiveFrequenceDay
        } else {
          this.settings['SRTP-ArchiveFrequence'] = newYear + ',0,0'
        }
      }
    },
    srtpArchiveFrequenceMonth: {
      get() {
        return this.settings['SRTP-ArchiveFrequence'] ? this.settings['SRTP-ArchiveFrequence'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['SRTP-ArchiveFrequence'] ? this.originalSettings['SRTP-ArchiveFrequence'].split(',')[1] : '0'
        }
        if (this.settings['SRTP-ArchiveFrequence']) {
          this.settings['SRTP-ArchiveFrequence'] = this.srtpArchiveFrequenceYear + ',' + newMonth + ',' + this.srtpArchiveFrequenceDay
        } else {
          this.settings['SRTP-ArchiveFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    srtpArchiveFrequenceDay: {
      get() {
        return this.settings['SRTP-ArchiveFrequence'] ? this.settings['SRTP-ArchiveFrequence'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['SRTP-ArchiveFrequence'] ? this.originalSettings['SRTP-ArchiveFrequence'].split(',')[2] : '0'
        }
        if (this.settings['SRTP-ArchiveFrequence']) {
          this.settings['SRTP-ArchiveFrequence'] = this.srtpArchiveFrequenceYear + ',' + this.srtpArchiveFrequenceMonth + ',' + newDay
        } else {
          this.settings['SRTP-ArchiveFrequence'] = '0,0,' + newDay
        }
      }
    },
    srtpLastArchive() {
      return this.$options.filters.formatDateTime(this.settings.SRTP_LastArchive)
    },
    srtpLastPurge() {
      return this.$options.filters.formatDateTime(this.settings.SRTP_LastPurge)
    },
    srtpPurgeDelayYear: {
      get() {
        return this.settings['SRTP-PurgeDelay'] ? this.settings['SRTP-PurgeDelay'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['SRTP-PurgeDelay'] ? this.originalSettings['SRTP-PurgeDelay'].split(',')[0] : '0'
        }
        if (this.settings['SRTP-PurgeDelay']) {
          this.settings['SRTP-PurgeDelay'] = newYear + ',' + this.srtpPurgeDelayMonth + ',' + this.srtpPurgeDelayDay
        } else {
          this.settings['SRTP-PurgeDelay'] = newYear + ',0,0'
        }
      }
    },
    srtpPurgeDelayMonth: {
      get() {
        return this.settings['SRTP-PurgeDelay'] ? this.settings['SRTP-PurgeDelay'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['SRTP-PurgeDelay'] ? this.originalSettings['SRTP-PurgeDelay'].split(',')[1] : '0'
        }
        if (this.settings['SRTP-PurgeDelay']) {
          this.settings['SRTP-PurgeDelay'] = this.srtpPurgeDelayYear + ',' + newMonth + ',' + this.srtpPurgeDelayDay
        } else {
          this.settings['SRTP-PurgeDelay'] = '0,' + newMonth + ',0'
        }
      }
    },
    srtpPurgeDelayDay: {
      get() {
        return this.settings['SRTP-PurgeDelay'] ? this.settings['SRTP-PurgeDelay'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['SRTP-PurgeDelay'] ? this.originalSettings['SRTP-PurgeDelay'].split(',')[2] : '0'
        }
        if (this.settings['SRTP-PurgeDelay']) {
          this.settings['SRTP-PurgeDelay'] = this.srtpPurgeDelayYear + ',' + this.srtpPurgeDelayMonth + ',' + newDay
        } else {
          this.settings['SRTP-PurgeDelay'] = '0,0,' + newDay
        }
      }
    },
    srtpPurgeFrequenceYear: {
      get() {
        return this.settings['SRTP-PurgeFrequence'] ? this.settings['SRTP-PurgeFrequence'].split(',')[0] : '0'
      },
      set(value) {
        let newYear = parseInt(value).toString()
        if (newYear === 'NaN') {
          this.resetInput = !this.resetInput
          newYear = this.originalSettings['SRTP-PurgeFrequence'] ? this.originalSettings['SRTP-PurgeFrequence'].split(',')[0] : '0'
        }
        if (this.settings['SRTP-PurgeFrequence']) {
          this.settings['SRTP-PurgeFrequence'] = newYear + ',' + this.srtpPurgeFrequenceMonth + ',' + this.srtpPurgeFrequenceDay
        } else {
          this.settings['SRTP-PurgeFrequence'] = newYear + ',0,0'
        }
      }
    },
    srtpPurgeFrequenceMonth: {
      get() {
        return this.settings['SRTP-PurgeFrequence'] ? this.settings['SRTP-PurgeFrequence'].split(',')[1] : '0'
      },
      set(value) {
        let newMonth = parseInt(value).toString()
        if (newMonth === 'NaN') {
          this.resetInput = !this.resetInput
          newMonth = this.originalSettings['SRTP-PurgeFrequence'] ? this.originalSettings['SRTP-PurgeFrequence'].split(',')[1] : '0'
        }
        if (this.settings['SRTP-PurgeFrequence']) {
          this.settings['SRTP-PurgeFrequence'] = this.srtpPurgeFrequenceYear + ',' + newMonth + ',' + this.srtpPurgeFrequenceDay
        } else {
          this.settings['SRTP-PurgeFrequence'] = '0,' + newMonth + ',0'
        }
      }
    },
    srtpPurgeFrequenceDay: {
      get() {
        return this.settings['SRTP-PurgeFrequence'] ? this.settings['SRTP-PurgeFrequence'].split(',')[2] : '0'
      },
      set(value) {
        let newDay = parseInt(value).toString()
        if (newDay === 'NaN') {
          this.resetInput = !this.resetInput
          newDay = this.originalSettings['SRTP-PurgeFrequence'] ? this.originalSettings['SRTP-PurgeFrequence'].split(',')[2] : '0'
        }
        if (this.settings['SRTP-PurgeFrequence']) {
          this.settings['SRTP-PurgeFrequence'] = this.srtpPurgeFrequenceYear + ',' + this.srtpPurgeFrequenceMonth + ',' + newDay
        } else {
          this.settings['SRTP-PurgeFrequence'] = '0,0,' + newDay
        }
      }
    },
    role() {
      return this.tabName
    }
  },
created() {
  this.environnments = [
    { "name": "development", "value": "4" },
    { "name": "qualification", "value": "3" },
    { "name": "staging", "value": "2" },
    { "name": "production", "value": "1" }
  ]
  this.getSettings()
},
  methods: {
    /*changeMaxAmountHRTP() {
      if (this.settings['HRTP-RTPSPMaxAmount']) {
        if (this.settings['HRTP-RTPSPMaxAmount'].includes('e')) {
          this.settings['HRTP-RTPSPMaxAmount'] = parseFloat(this.settings['HRTP-RTPSPMaxAmount'].split('e')[0]) * Math.pow(10, parseInt(this.settings['HRTP-RTPSPMaxAmount'].split('e')[1]))
        }
        if (this.settings['HRTP-RTPSPMaxAmount'].length > 16) {
          let partAfterVirgule = parseFloat('.' + this.settings['HRTP-RTPSPMaxAmount'].slice(this.settings['HRTP-RTPSPMaxAmount'].indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.settings['HRTP-RTPSPMaxAmount'].split('.')[0]
          this.settings['HRTP-RTPSPMaxAmount'] = partBeforeVirgule + partAfterVirgule
        } else {
          this.settings['HRTP-RTPSPMaxAmount'] = parseFloat(this.settings['HRTP-RTPSPMaxAmount']).toFixed(2).toString()
        }
      } else {
        return
      }
    },
    changeMaxAmountSRTP() {
      if (this.settings['SRTP-RTPSPMaxAmount']) {
        if (this.settings['SRTP-RTPSPMaxAmount'].includes('e')) {
          this.settings['SRTP-RTPSPMaxAmount'] = parseFloat(this.settings['SRTP-RTPSPMaxAmount'].split('e')[0]) * Math.pow(10, parseInt(this.settings['SRTP-RTPSPMaxAmount'].split('e')[1]))
        }
        if (this.settings['SRTP-RTPSPMaxAmount'].length > 16) {
          let partAfterVirgule = parseFloat('.' + this.settings['SRTP-RTPSPMaxAmount'].slice(this.settings['SRTP-RTPSPMaxAmount'].indexOf('.') + 1)).toFixed(2)
          partAfterVirgule = partAfterVirgule.substring(1)
          let partBeforeVirgule = this.settings['SRTP-RTPSPMaxAmount'].split('.')[0]
          this.settings['SRTP-RTPSPMaxAmount'] = partBeforeVirgule + partAfterVirgule
        } else {
          this.settings['SRTP-RTPSPMaxAmount'] = parseFloat(this.settings['SRTP-RTPSPMaxAmount']).toFixed(2).toString()
        }
      } else {
        return
      }
    },
    changeMaxLinesExportRTP() {
      let newMonth = parseInt(this.settings['RTPMaxLinesExport'], 10).toString()
      if (newMonth === 'NaN' || !newMonth) {
        this.settings['RTPMaxLinesExport'] = this.originalSettings['RTPMaxLinesExport']
        this.resetInput = !this.resetInput
        return
      }
      this.settings['RTPMaxLinesExport'] = parseInt(this.settings['RTPMaxLinesExport'], 10).toString()
    },
    changeSettingInterval(value, stringParam) {
      let formatedValue

      formatedValue = value.replace(/[YM]/g, ',')
      formatedValue = formatedValue.replace(/[D]/g, '')
      this.settings[stringParam] = formatedValue
    },
    changeSettingInterval(value, stringParam) {
      let formatedValue

      formatedValue = value.replace(/[YM]/g, ',')
      formatedValue = formatedValue.replace(/[D]/g, '')
      this.settings[stringParam] = formatedValue
    },
    changeTimeBeforeExpSRTP() {
      if (this.settings.RTPSPTimeBeforeExpiration) {
        this.settings.RTPSPTimeBeforeExpiration = parseInt(this.settings.RTPSPTimeBeforeExpiration, 10).toString()
      } else {
        return
      }
    },
    changeVldityPeriodHRTP() {
      if (this.settings['HRTP-ValidityPeriod']) {
        this.settings['HRTP-ValidityPeriod'] = parseInt(this.settings['HRTP-ValidityPeriod'], 10).toString()
      } else {
        return
      }
    },
    controlMaxAmountHRTP() {
      let newAmount = parseFloat('.' + this.settings['HRTP-RTPSPMaxAmount'].slice(this.settings['HRTP-RTPSPMaxAmount'].indexOf('.') + 1)).toFixed(2)
      if (newAmount === 'NaN' || !newAmount) {
        this.settings['HRTP-RTPSPMaxAmount'] = this.originalSettings['HRTP-RTPSPMaxAmount']
        this.resetInput = !this.resetInput
        return
      }
    },
    controlMaxAmountSRTP() {
      let newAmount = parseFloat('.' + this.settings['SRTP-RTPSPMaxAmount'].slice(this.settings['SRTP-RTPSPMaxAmount'].indexOf('.') + 1)).toFixed(2)
      if (newAmount === 'NaN' || !newAmount) {
        this.settings['SRTP-RTPSPMaxAmount'] = this.originalSettings['SRTP-RTPSPMaxAmount']
        this.resetInput = !this.resetInput
        return
      }
    },
    controlTimeBeforeExpSRTP() {
      let newTimer = parseInt(this.settings.RTPSPTimeBeforeExpiration, 10).toString()
      if (newTimer === 'NaN' || !newTimer) {
        this.settings.RTPSPTimeBeforeExpiration = this.originalSettings.RTPSPTimeBeforeExpiration
        this.resetInput = !this.resetInput
        return
      }
    },
    controlTimeBeforeExpHRTP() {
      let newTimer = parseInt(this.settings['HRTP-ValidityPeriod'], 10).toString()
      if (newTimer === 'NaN' || !newTimer) {
        this.settings['HRTP-ValidityPeriod'] = this.originalSettings['HRTP-ValidityPeriod']
        this.resetInput = !this.resetInput
        return
      }
    },*/


    getSettings() {
      this.activateSpinner = true
      let that = this
      this.$engine.sddSettings.fetchGlobalSDDSettings().then((resp) => {
        const s = resp.data.GlobalSDDSettings
        Object.keys(that.settings).forEach((key) => {
          if (s[key] !== undefined) {
            that.settings[key] = s[key]
          }
        })
        that.activateSpinner = false
        that.originalSettings = Object.assign({}, that.settings)
      }).catch((e) => {
        console.error('SDD GET error:', e)
        that.activateSpinner = false
        errorMessageAlert(e, that)
      })
    },
    editSettings() {
      this.doesEdit = true
    },
    hasRight(right) {
      return this.$engine.rights.rightIs(right, true)
    },
    resetSettings() {
      this.settings = Object.assign({}, this.originalSettings)
      this.doesEdit = false
      this.resetInput = !this.resetInput
    },
    updateSettings(settings) {
      let that = this
      const maxLines = parseInt(this.settings['NbMaxDowloadData' + this.suffix])
      if (isNaN(maxLines) || maxLines < 0) {
        this.settings['NbMaxDowloadData' + this.suffix] = this.originalSettings['NbMaxDowloadData' + this.suffix]
        this.resetInput = !this.resetInput
        return
      }

      // // CHECK GLOBAL SETTINGS
      // if (!this.settings['RTPMaxLinesExport']) {
      //   this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', { field: this.$t('settings.max_lines_export') }))
      //   return
      // }
      // if (!this.settings['Environment']) {
      //   this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', { field: this.$t('settings.environnment_type') }))
      //   return
      // }

      // // CHECK SRTP SETTINGS
      // if (this.canSeeSRTP) {
      //   if (!this.settings.RTPSPIdentifier) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_identifier')}))
      //     return
      //   }
      //   if (!this.settings['SRTP-API-AccountValidation']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_api_accountvalidation')}))
      //     return
      //   }
      //   if (!this.settings.RTPSPTimeBeforeExpiration) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_time_before_expiration')}))
      //     return
      //   }
      //   if (!this.settings['SRTP-RTPSPMaxAmount']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.max_amnt_srtp')}))
      //     return
      //   }
      //   if (!this.settings['SRTP-PurgeFrequence']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_purge_freq')}))
      //     return
      //   }
      //   if (!this.settings['SRTP-PurgeDelay']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_purge_delay')}))
      //     return
      //   }
      //   if (!this.settings['SRTP-ArchiveFrequence']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_archive_freq')}))
      //     return
      //   }
      //   if (!this.settings['SRTP-ArchiveDelay']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.srtp_archive_delay')}))
      //     return
      //   }
      // }

      // // CHECK HRTP SETTINGS
      // if (this.canSeeHRTP) {
      //   if (!this.settings['HRTP-Identifier']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.hrtp_identifier')}))
      //     return
      //   }
      //   if (!this.settings['HRTP-API-AccountValidation']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.hrtp_api_accountvalidation')}))
      //     return
      //   }
      //   if (!this.settings['HRTP-RTPSPMaxAmount']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.max_amnt_hrtp')}))
      //     return
      //   }
      //   if (!this.settings['HRTP-ValidityPeriod']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('administration.rtp_h_validity_period')}))
      //     return
      //   }
      //   if (!this.settings['HRTP-PurgeFrequence']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_purge_freq')}))
      //     return
      //   }
      //   if (!this.settings['HRTP-PurgeDelay']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_purge_delay')}))
      //     return
      //   }
      //   if (!this.settings['HRTP-ArchiveFrequence']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_archive_freq')}))
      //     return
      //   }
      //   if (!this.settings['HRTP-ArchiveDelay']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.hrtp_archive_delay')}))
      //     return
      //   }
      // }

      // // CHECK SRTP SETTINGS
      // if (this.canSeePSD2) {
      //   if (!this.settings['PSD2-Token.io-RedirectURL']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.tokenio_redirecturl')}))
      //     return
      //   }
      //   if (!this.settings['PSD2-PurgeFrequence']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_purge_freq')}))
      //     return
      //   }
      //   if (!this.settings['PSD2-PurgeDelay']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_purge_delay')}))
      //     return
      //   }
      //   if (!this.settings['PSD2-ArchiveFrequence']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_archive_freq')}))
      //     return
      //   }
      //   if (!this.settings['PSD2-ArchiveDelay']) {
      //     this.$f7.alert(this.$t('errors.errors_in_form_details'), this.$t('errors.errors_missing_field', {field: this.$t('settings.psd2_archive_delay')}))
      //     return
      //   }
      // }

      let array = []
      let changedSettings = {}

      Object.keys(settings).forEach((key) => {
        if (settings[key] !== this.originalSettings[key]) {
          changedSettings[key] = settings[key]
        }
      })
      Object.entries(changedSettings).forEach((element) => {
        let object = {}
        object = {
          name: element[0],
          value: element[1],
        }
        array.push(object)
      })

      let data = array
      this.$engine.sddSettings
        .updateGlobalSDDSettings({ data }) // TODO: redirection vers la page SDD settings après sauvegarde // loadPage(that, { url: "/settings/sddSettings/" })
        .then((resp) => {
          this.originalSettings = Object.assign({}, settings)
          this.doesEdit = false
          that.$f7.modal({
            title: that.$i18n.t("settings.settings_modified"),
            buttons: [
              {
                text: "OK",
                onClick: function () {
                  return
                },
              },
            ],
          })
          // loadPage(that, { url: "/settings/rtpSettings/" })
        })
        .catch((e) => {
          let errMsgTitle = ''
          let errMsgDesc = ''
          if (e && e.response && e.response.data && e.response.data.error) {
            let errParsed = e.response.data.error.replace(/\s+/g, '')
            if (('errors._specific.title.' + errParsed) !== that.$t('errors._specific.title.' + errParsed)) {
              errMsgTitle = that.$t('errors._specific.title.' + errParsed)
              errMsgDesc = that.$t('errors._specific.description.' + errParsed)
            }
          }
          if (errMsgTitle && errMsgDesc) {
            that.$f7.alert(errMsgDesc, errMsgTitle)
          } else {
            errorMessageAlert(e, that)
          }
        })
    },
  },
}
</script>
<style scoped>
.btn.btn-secondary {
  background: var(--actionButtonColorViolet);
  border: 2px solid var(--borderButtonColorBlue);
  color: var(--actionTextColorBlue);
}

.sdd-select {
  display: block;
  width: 90px;
}

.justify-content-around label {
  display: block;
  font-size: 0.82rem;
  color: #6c757d;
  margin-bottom: 2px;
}

.justify-content-around label.sdd-label-main,
.d-flex label.sdd-label-main {
  font-size: 1rem !important;
  color: #212529 !important;
  margin-bottom: 1rem !important;
}
.sdd-select-header label {
  display: block;
  text-align: center;
  font-size: 1rem !important;
  color: #212529 !important;
  margin-bottom: 2px;
}
.justify-content-around label:not(.sdd-label-main) {
  font-size: 1rem !important;
  color: #212529 !important;
}
</style>
